import Router, { useRouter as useNextRouter } from "next/router";
import { useCallback } from "react";

import type { RouteParamsShape, SetParamsOptions } from "../params";

export const useRouteParams = (): {
  params: Readonly<Record<string, unknown>>;
  setParams: (
    value: Partial<RouteParamsShape>,
    options?: SetParamsOptions,
  ) => void;
} => {
  const { query } = useNextRouter();
  const setParams = useCallback(
    (value: Partial<RouteParamsShape>, options?: SetParamsOptions) => {
      const merged = { ...Router.query, ...value };
      for (const [key, next] of Object.entries(value)) {
        if (next === null || next === undefined) {
          delete merged[key];
        }
      }
      void Router[options?.webBehavior ?? "push"](
        { pathname: Router.pathname, query: merged },
        undefined,
        { shallow: true },
      );
    },
    [],
  );
  return { params: query, setParams };
};
